import { v4 as uuidv4 } from "uuid";

const PLAYER_KEY = "pig_player_id";

export function getPlayerId() {
  let id = localStorage.getItem(PLAYER_KEY);

  if (!id) {
    id = uuidv4();
    localStorage.setItem(PLAYER_KEY, id);
  }

  return id;
}
